import serverCall from "../serverCall";

const getFqqQuestion = async (page, all) => {
  try {
    const response = await serverCall.get(
      `/faq/getall?page=${page}&limit=${all ? 500 : 12}`
    );
    return response;
  } catch (error) {
    console.log("get map error", error);
  }
};

const CreateFaqAddQuestion = async (name) => {
  const response = await serverCall.post(`${process.env.REACT_APP_BASE_API_URL}/faq/admin/create`, name);
  return response;
};

const GetFaqSingleId = async (id) => {
  try {
    const response = await serverCall.get(`/faq/${id}`);
    return response;
  } catch (error) {
    console.log("GetFaqSingleId Api error", error);
  }
};

const DeleteFaqDataRequest = async (id) => {
  try {
    const response = await serverCall.delete(`/faq/admin/delete/${id}`);
    return response;
  } catch (error) {
    console.log("DeleteFaqId Api error", error);
  }
};

const UpdateFaqDataRequest = async (id, name) => {
  try {
    const response = await serverCall.put(`/faq/admin/update/${id}`, name);
    return response;
  } catch (error) {
    console.log("GetFaqSingleId Api error", error);
  }
};

const UpdateFaqPositionRequest = async (data) => {
  try {
    const response = await serverCall.put(`/faq/admin/update-position`, data);
    return response;
  } catch (error) {
    console.log("GetFaqSingleId Api error", error);
  }
};

const FaqData = {
  getFqqQuestion,
  CreateFaqAddQuestion,
  DeleteFaqDataRequest,
  UpdateFaqDataRequest,
  GetFaqSingleId,
  UpdateFaqPositionRequest
};

export default FaqData;
